import React from "react";
import DoneAllIcon from "@material-ui/icons/DoneAll";

export type InlineAlertSelectedProps = {
  message: string;
  count: number;
  isSelected: boolean;
};

export const InlineAlertSelected = (props: InlineAlertSelectedProps) => {
  return (
    <div
      className={`font-weight-bold inline-alert-selected ${
        !props.isSelected ? "alert-selected" : ""
      }`}
    >
      <DoneAllIcon />
      <span>{" " + props.count + " " + props.message}</span>
    </div>
  );
};
